import React, { useCallback, useContext, useEffect, useState } from "react"
import {
    Text,
    View,
    StyleSheet,
    FlatList,
    RefreshControl,
} from "react-native"

import { AuthContext } from '../../contexts/auth/Store';
import { AnalyticsService } from "../../constants/Analytics";
import GridView from '../../components/product/GridView';
import GenericHeader from '../../components/headers/GenericHeader';
import Colors from "../../constants/Colors";
import { useFocusEffect, useNavigation, useRoute } from "@react-navigation/native";
import BrandService from "../../services/BrandService";
import { IBrand } from "../../interfaces/brand";
import { IManufacturer } from "../../interfaces/manufacturer";
import ManufacturerService from "../../services/ManufacturerService";
import { unionBy } from 'lodash';

const analytics = new AnalyticsService();
const brandService = new BrandService();
const manufacturerService = new ManufacturerService();

function ManufacturerBrandScreen() {
    const route = useRoute();
    const navigation = useNavigation();

    const auth: any = useContext(AuthContext)
    const buyer = auth.getUserData.buyerData

    const [isLoading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false)
    const [manufacturer, setManufacturer]: [IManufacturer | null, any] = useState(null)
    const [brands, setBrands]: [IBrand[], any] = useState([])

    const fetch_manufacturer_brands = (_id: string) => {
        if (!brands.length) {
            setLoading(true)
        }
        brandService.fetchByManufacturer(
            _id
        )
            .then(res => {
                res = res.filter(brand => brand.status === 'active')
                setBrands(prev => unionBy(prev, res, '_id'))
                setLoading(false)
                setRefreshing(false)
            })
            .catch(err => {
                setLoading(false)
                setRefreshing(false)
            })
    }

    const refresh_page = () => {
        setRefreshing(true)
        if (manufacturer) {
            fetch_manufacturer_brands(manufacturer._id)
        }
    }

    const initialize = (id: string) => {
        manufacturerService
            .fetchById(id)
            .then(res => {
                setManufacturer(res)

                analytics.logEvent('Viewed Manufacturer', auth.getUserData.buyerData, { manufacturer_data: res })
                analytics.googleHelpers.setCurrentScreen('ViewedManufacturer', 'ViewedManufacturer')

                setBrands([{ _id: 'brand_001', upload: { path: res.upload.path }, name: `All ${res.name} Products` }])
                fetch_manufacturer_brands(id)
                navigation.setOptions({
                    title: res.name + ' Brands - Suplias Now'
                })
            })
            .catch(err => {
                console.log(err)
                nav_back()
            })
    }

    const nav_handler = (brand: IBrand) => {
        if (brand._id === 'brand_001') {
            navigation.navigate('ManufacturerProduct', {
                id: manufacturer?._id
            })
        } else {
            navigation.navigate('BrandProduct', {
                id: brand._id
            })
        }
    }

    const nav_back = () => {
        navigation.navigate('HomeTab', {
            screen: 'Manufacturer'
        })
    }

    useFocusEffect(
        useCallback(() => {
            // the screen is focused, take actions
            if (!route.params?.id) {
                nav_back()
            } else {
                initialize(route.params?.id)
            }

            return () => {
                // screen is blurred, take actions
                setManufacturer(null)
                setBrands([])
            };
        }, [route.params])
    );

    return <>
        <GenericHeader
            title={`${manufacturer ? manufacturer.name + ' Brands' : 'Manufacturer Brands'}`}
            backAction={nav_back}
        />
        <View style={styles.container}>
            {
                isLoading 
                    ? <FlatList
                        initialNumToRender={10}
                        data={[1, 2, 3, 4, 5, 6, 7, 8, 9 ]}
                        renderItem={({ item, index }) => <GridView index={index} model={item} key={index} />}
                        keyExtractor={item => `${item}`}
                        key={3}
                        numColumns={3}
                        contentContainerStyle={styles.scrollView}
                    />
                    : <FlatList
                        initialNumToRender={10}
                        data={brands}
                        renderItem={({ item, index }) => <GridView index={index} model={item} key={index} action={() => nav_handler(item)} rounded={true} />}
                        keyExtractor={item => `${item._id}`}
                        key={3}
                        numColumns={3}
                        contentContainerStyle={styles.scrollView}
                        onEndReached={() => {
                            refresh_page()
                        }}
                        onEndReachedThreshold={2}
                        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={refresh_page} />}
                    />
            }
        </View>
    </>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.whiteColor
    },
    scrollView: {
        backgroundColor: Colors.whiteColor,
    }
})

export default ManufacturerBrandScreen